$(function () {

    //SLICK SLIDER
    $('.slick-slider').slick({
        draggable: true,
        dots: false,
        arrows: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        speed: 650,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>'
    });

    $('.img-slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        adaptiveHeight: true
    });

    if ($("[data-fancybox]").length > 0) {
        $("[data-fancybox]").fancybox({
            // Options will go here
        });
    }
    if ($(".projecten-wrapper").length > 0) {
        $(".projecten-wrapper").gridalicious({width: 300, gutter: 40, selector: '.project-wrapper'});
    }


    // SETUP FORMS
    setup_forms();

    $('.close-splash').click(function () {
        $('.splash-overlay').fadeOut();
    });
});

$(window).load(function () {
    $('.lg-image').on('click', function () {
        if ($('.lg-img-list li').length > 0) {
            var lgimgs = [];
            $(this).find('.lg-img-list li').each(function () {
                lgimg = {
                    src: $(this).attr('data-img'),
                    thumb: $(this).attr('data-thumb'),
                    subHtml: $(this).attr('data-text')
                };
                lgimgs.push(lgimg);
            });
            $(this).lightGallery({
                dynamic: true,
                loop: false,
                dynamicEl: lgimgs,
                download: false
            });
        }
    });
});

$('.modal-accept').click(function () {
    $('.modal-overlay').remove();
});

$('.mm-btn').click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.mm-menu').slideUp();
        $('body').removeClass('overflow');
    } else {
        $(this).addClass('active');
        // $('.mm-menu').addClass('active');
        $('.mm-menu').slideDown();
        $('body').addClass('overflow');
    }
});

function scrollToDiv(name) {
    $('html,body').animate({scrollTop: $("div[name='" + name + "']").offset().top});
}

if ($('.companySelect').length > 0) {
    $('.companySelect').change(function () {
        if ($(this).hasClass('hideCompany')) {
            $('.bedrijfInput').hide()
            $('.bedrijfInput input').prop('required', false).removeClass('required');
        } else {
            $('.bedrijfInput').show();
            $('.bedrijfInput input').prop('required', true).addClass('required');

        }
    });
}

function getResetpw() {
    $.ajax({
        type: "post",
        url: "/custom/ajax.php",
        data: {
            ajax_call: 'resetpw'
        },
        success: function (data) {
            $('body').append(data);
            $('.resetpwform').validate({
                submitHandler: function (form) {
                    form.submit();
                }
            });
        }
    });
}
$('.forgot-pw').click(function () {
    getResetpw();
});

// FORMS VALIDATE
function setup_forms() {
    if ($('form').length) {
        jQuery.validator.setDefaults({
            onkeyup: false,
            ignoreTitle: true,
            rules: {
                'fld-password': {minlength: 8},
                'number': {number: true},
                'verdieping': {digits: true}
            }
        });
        $('.formcontact').validate({
            submitHandler: function (form) {
                form.submit();
            }
        });
        $('.loginform').validate({
            submitHandler: function (form) {
                form.submit();
            }
        });
        $('.registrationform').validate({
            submitHandler: function (form) {
                form.submit();
            }
        });

    }
}

/**
 * NICK :: play/pause video on scroll
 */
var first_time_video_play = true;

$(window).scroll(function()
{
    var $videoNormal = $('.video-normal');
    if ($videoNormal.length) {
        if(!$videoNormal.is(':in-viewport')) {
            // console.log('not-in-viewport');
            $videoNormal.get(0).pause();
        } else {
            // console.log('in-viewport');
            if(first_time_video_play) { first_time_video_play = false;
                $videoNormal.get(0).play();
            }
        }
    }
});


//https://github.com/zeusdeux/isInViewport/blob/master/license.md MIT
!function(a,b){function c(b){var c,d=a("<div></div>").css({width:"100%"});return b.append(d),c=b.width()-d.width(),d.remove(),c}function d(e,f){var g=e.getBoundingClientRect(),h=g.top,i=g.bottom,j=g.left,k=g.right,l=a.extend({tolerance:0,viewport:b},f),m=!1,n=l.viewport.jquery?l.viewport:a(l.viewport);n.length||(console.warn("isInViewport: The viewport selector you have provided matches no element on page."),console.warn("isInViewport: Defaulting to viewport as window"),n=a(b));var o=n.height(),p=n.width(),q=n.get(0).toString();if(n[0]!==b&&"[object Window]"!==q&&"[object DOMWindow]"!==q){var r=n.get(0).getBoundingClientRect();h-=r.top,i-=r.top,j-=r.left,k-=r.left,d.scrollBarWidth=d.scrollBarWidth||c(n),p-=d.scrollBarWidth}return l.tolerance=~~Math.round(parseFloat(l.tolerance)),l.tolerance<0&&(l.tolerance=o+l.tolerance),0>=k||j>=p?m:m=l.tolerance?!!(h<=l.tolerance&&i>=l.tolerance):!!(i>0&&o>=h)}String.prototype.hasOwnProperty("trim")||(String.prototype.trim=function(){return this.replace(/^\s*(.*?)\s*$/,"$1")});var e=function(b){if(1===arguments.length&&"function"==typeof b&&(b=[b]),!(b instanceof Array))throw new SyntaxError("isInViewport: Argument(s) passed to .do/.run should be a function or an array of functions");for(var c=0;c<b.length;c++)if("function"==typeof b[c])for(var d=0;d<this.length;d++)b[c].call(a(this[d]));else console.warn("isInViewport: Argument(s) passed to .do/.run should be a function or an array of functions"),console.warn("isInViewport: Ignoring non-function values in array and moving on");return this};a.fn["do"]=function(a){return console.warn("isInViewport: .do causes issues in IE and some browsers since its a reserved. Use $.fn.run instead i.e., $(el).run(fn)."),e(a)},a.fn.run=e,a.extend(a.expr[":"],{"in-viewport":function(a,b,c){if(c[3]){var e=c[3].split(",");return 1===e.length&&isNaN(e[0])&&(e[1]=e[0],e[0]=void 0),d(a,{tolerance:e[0]?e[0].trim():void 0,viewport:e[1]?e[1].trim():void 0})}return d(a)}})}(jQuery,window);